export class JobStopComment {
    constructor(json) {
        this.id = json.id;
        this.stopId = json.stop_id;
        this.comment = json.comment;
        this.reason = json.reason;
    }
}
//# sourceMappingURL=JobStopComment.js.map